import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

export const useOnCloseGoToList = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  return () => {
    navigate(navigation.employees.list.fullPath())
  }
}
